import { AppointmentCreatedBy } from "./appointment";
import { Customer } from "./customer";
import { Invoice } from "./invoice";
import { Permit } from "./permit";
import { Photo } from "./photo";
import { Quote } from "./quote";
import { Tag } from "./tag";
import { Technician, TechnicianDepartment } from "./technician";

export type JobOpportunityStatus = "open" | "won" | "lost" | "invalid";

export class JobAppointment {
  arrival_time: string | null = null;
  scheduled_time = "";
  arrival_window_minutes: number | null = null;
  assignment_pinned = false;
  created_time = "";
  crew_members: any[] = []; // TODO: Define
  customer: Customer = new Customer();
  customer_scheduled = false;
  departure_time: string | null = null;
  dispatch_time: string | null = null;
  duration_minutes: number | null = null;
  enforce_actual_times = false;
  estimated_duration_minutes = -1;
  estimated_end_time = "";
  id = -1;
  job_id = -1;
  links: any; // TODO: Define
  min_arrival_time = "";
  pinned_reason: string | null = null;
  service_category = {
    archived: false,
    duration_minutes: 0,
    id: -1,
    name: "",
    priority: ""
  };
  settings = {
    late_fee_per_minute_cents: -1,
    max_late_fee_cents: -1
  };
  status = "";
  technician: Technician | null = null;
  total_duration_minutes: number | null = null;
  total_travel_minutes: number | null = null;
  total_work_minutes: number | null = null;
  travel_minutes: number | null = null;
  work_minutes: number | null = null;
  created_by = new AppointmentCreatedBy();

  constructor(params: Partial<JobAppointment> = {}) {
    Object.assign(this, params);
  }
}

export class Job {
  id = -1;
  permit_required = false;
  customer = new Customer();
  permit = {
    id: -1,
    status: "",
    inspection_date: "" // Date in MM/DD/YYYY format
  };
  invoice: Invoice | null = null;
  photos: Photo[] = [];
  documents: Document[] = [];
  links = {
    quote_create: "",
    quote_list: "",
    quote_accept: ""
  };
  address = {
    time_zone: "",
    id: -1
  };
  quotes: Quote[] = [];
  appointments: JobAppointment[] = [];
  tags: Tag[] | null | undefined;
  constructor(params: Partial<Job> = {}) {
    Object.assign(this, params);
  }

  get billing_address() {
    return this.customer.billing_address;
  }

  get service_address() {
    return this.address;
  }
}

export class JobShortV2 {
  id = -1;
  opportunity_status: JobOpportunityStatus = "open";
  appointment_count = 0;
  department = new TechnicianDepartment();
  permits: Permit[] = [];
  invoice_revenue_cents: number;
  status: {
    color: string;
    created_at: string;
    description: string;
    final: boolean;
    id: number;
    key: string;
    name: string;
    position: number;
    updated_at: string;
  };
  tags: Tag[] | null | undefined;
}
